import { get, httpDelete, patch, post } from "@readai/common/api";
import { parseUTCDateTimeFromString } from "@readai/common/utils/datetimeUtils";

import type {
  ApiRssLinkCalendarEvent,
  RssLinkCalendarEvent,
  RssLinkCalendarEventCancelBody,
  RssLinkCalendarEventCreateBody,
} from "@app/booking/types/rssLinkTypes";

const parseRssLinkCalendarEventFromResponse = (
  event: ApiRssLinkCalendarEvent,
) => {
  return {
    ...event,
    startTime: parseUTCDateTimeFromString(event.startTime),
    endTime: parseUTCDateTimeFromString(event.endTime),
  };
};

const BASE_ROUTE = "/rss_link_calendar_events";
export const getRssLinkCalendarEvent = async (
  eventId: string,
): Promise<RssLinkCalendarEvent> => {
  const response = await get(`${BASE_ROUTE}/${eventId}`);
  return parseRssLinkCalendarEventFromResponse(response);
};

export const createRssLinkCalendarEvent = (
  scheduleEventBody: RssLinkCalendarEventCreateBody,
) => post(BASE_ROUTE, scheduleEventBody);

export const cancelRssLinkCalendarEvent = ({
  eventId,
  cancelEventBody,
}: {
  eventId: string;
  cancelEventBody: RssLinkCalendarEventCancelBody;
}) =>
  httpDelete(`${BASE_ROUTE}/${eventId}`, { withCreds: true }, cancelEventBody);

export const patchRssLinkCalendarEvent = ({
  eventId,
  patchBody,
}: {
  eventId: string;
  patchBody: Partial<RssLinkCalendarEventCreateBody>;
}) => patch(`${BASE_ROUTE}/${eventId}`, patchBody);
